/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit WidgetPlaceholder/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function WidgetPlaceholder({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/WidgetPlaceholder",
  isSubmitting
  
}) {
let paymentContainerIdValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'containerId',
})
let paymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payment',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="WidgetPlaceholder.Vertical"
  data-view-path={viewPath}
 id={paymentContainerIdValueData}
 key={paymentContainerIdValueData}
 style={{'--mt-1-6XN1c': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pe-2-6XN1c': paymentIsSubmittingData ? "none" : "auto"}}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}